import { render, staticRenderFns } from "./ClientSearch.vue?vue&type=template&id=08223afc&scoped=true&"
import script from "./ClientSearch.vue?vue&type=script&lang=js&"
export * from "./ClientSearch.vue?vue&type=script&lang=js&"
import style0 from "./ClientSearch.vue?vue&type=style&index=0&id=08223afc&prod&scoped=true&lang=css&"
import style1 from "./ClientSearch.vue?vue&type=style&index=1&id=08223afc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08223afc",
  null
  
)

export default component.exports